<div class="active-process-card" [class.active-card]="isActive" [class.violation-card]="hasViolation">

  <!-- Header: License Plate & Live Status Badge -->
  <div class="card-header">
    <div class="plate-wrapper">
      <app-plate
        size="md"
        [number]="plateNumber"
        [euBand]="plateEuBand"
        [countryCode]="plateCountryCode"
        [region]="plateRegion"
        [regionSeparator]="plateRegionSeparator"
      />
    </div>

    <div class="status-badge" [class.status-live]="isActive" [class.status-alert]="hasViolation" [class.status-done]="!isActive && !hasViolation">
      @if (hasViolation) {
        <mat-icon class="badge-icon">error</mat-icon>
        <span>Violation</span>
      } @else if (isActive) {
        <span class="live-dot"></span>
        <span>Active</span>
      } @else {
        <mat-icon class="badge-icon">check_circle</mat-icon>
        <span>Completed</span>
      }
    </div>
  </div>

  <!-- Body: Responsive Info Grid -->
  <div class="details-grid">

    <!-- Location Block -->
    <div class="info-block">
      <div class="info-icon-box location-box">
        <mat-icon>location_on</mat-icon>
      </div>
      <div class="info-meta">
        <span class="info-label">Parking Location</span>
        <span class="info-value main-loc">{{ zoneName }}</span>
        @if (spaceName) {
          <span class="info-sub">{{ spaceName }}</span>
        }
      </div>
    </div>

    <!-- Started At Block -->
    <div class="info-block">
      <div class="info-icon-box time-box">
        <mat-icon>schedule</mat-icon>
      </div>
      <div class="info-meta">
        <span class="info-label">Entry Time</span>
        <span class="info-value">{{ startedAt | date:'mediumDate' }}, {{ startedAt | date:'shortTime' }}</span>
      </div>
    </div>

    <!-- Duration Block -->
    <div class="info-block duration-block">
      <div class="info-icon-box duration-box">
        <mat-icon>timer</mat-icon>
      </div>
      <div class="info-meta">
        <span class="info-label">Current Duration</span>
        <span class="info-value duration-val">{{ formattedDuration }}</span>
      </div>
    </div>

  </div>

  <!-- Violation Alert Banner if applicable -->
  @if (hasViolation && violationType) {
    <div class="violation-banner">
      <mat-icon>warning</mat-icon>
      <span>{{ violationType }}</span>
    </div>
  }

</div>